<template>
	<div class='tax-data-table'>
		<!-- {{ startLayerList.map(item => item.layer_id) }} -->
		<p-message severity='warn' v-if='liquidMoreFelling'>
			Захламленность ликвида > Общая захламленность 
    </p-message>

		<table class='tax-table table-common'>
			<thead>
				<tr>
					<th rowspan='3'>№ выдела</th>
					<th rowspan='3'>Площадь, га</th>
					<th rowspan='3'>Ярус</th>
					<th rowspan='3'>Состав</th>
					<th rowspan='3'>Доля участия породы</th>
					<th rowspan='3'>Порода</th>
					<th rowspan='3'>Возраст, лет</th>
					<th rowspan='3'>Высота, м</th>
					<th rowspan='3'>Диаметр, см</th>
					<th rowspan='3'>Бонитет</th>
					<th rowspan='3'>Тип леса</th>
					<th rowspan='3'>ТЛУ</th>
					<th rowspan='3'>Полнота</th>
					<th rowspan='3'>Запас сырорастущий, куб.м/га</th>
					<th colspan='5'>Запас на выделе, кбм</th>
				</tr>
				<tr>
					<th rowspan='2'>Сухостоя (старого)</th>
					<th rowspan='2'>Редин</th>
					<th rowspan='2'>Единич. дер.</th>
					<th colspan='2'>Захламленность</th>
				</tr>
				<tr>
					<th>общая</th>
					<th>ликвида</th>
				</tr>
			</thead>
			<tbody>
				<!-- <template v-if='selectedTax'>
					<template v-for='(layer, layer_i) in selectedTax.layers'>
						<template v-for='(species, species_i) in layer.species.filter(s => s.is_extra !== "t")'>
							<tr>
								<td v-if='layer_i === 0 && species_i === 0' :rowspan='totalSpeciesCount()'>{{ selectedTax.section }}</td>
								<td v-if='layer_i === 0 && species_i === 0' :rowspan='totalSpeciesCount()'>{{ selectedTax.s }}</td>
								<td v-if='species_i === 0' :rowspan='layerSpeciesCount(layer)'>{{ layer.layer }}</td>
								<td v-if='species_i === 0' :rowspan='layerSpeciesCount(layer)'>{{ layer.composition }}</td>
								<td>{{ species.coeff }}</td>
								<td>{{ species.name }}</td>
								<td>{{ species.age }}</td>
								<td>{{ species.h }}</td>
								<td>{{ species.d }}</td>
								<td v-if='layer_i === 0 && species_i === 0' :rowspan='totalSpeciesCount()'>{{ selectedTax.bonitet_id }}</td>
								<td v-if='layer_i === 0 && species_i === 0' :rowspan='totalSpeciesCount()'>{{ selectedTax.forest_type }}</td>
								<td v-if='layer_i === 0 && species_i === 0' :rowspan='totalSpeciesCount()'>{{ selectedTax.tlu }}</td>

								<td v-if='species_i === 0' :rowspan='layerSpeciesCount(layer)'>{{ layer.fullness }}</td>
							</tr>
						</template>
					</template>
				</template> -->
				<tr v-for='(item, item_i) in selectedTax'>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.section }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.s }}</td>
					<td v-if='isStartLayer(item)' :rowspan='getLayerRowCount(item)'>{{ item.layer == 11 ? 'единичные деревья': item.layer  }}</td>
					<td v-if='isStartLayer(item)' :rowspan='getLayerRowCount(item)'>{{ item.composition }}</td>
					<td>{{ item.coeff !== '0' ? item.coeff : '+' }}</td>
					<td>{{ item.species_name }}</td>
					<td>{{ item.age }}</td>
					<td>{{ item.h }}</td>
					<td>{{ item.d }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.bonitet }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.forest_type }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.tlu }}</td>
					<td v-if='isStartLayer(item)' :rowspan='getLayerRowCount(item)'>{{ item.fullness }}</td>
					<td v-if='isStartLayer(item)' :rowspan='getLayerRowCount(item)'>{{ item.stock }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.stock_dead }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.stock_open_stand }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.stock_single_tree }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.stock_felling_debris }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.stock_liquid_debris }}</td>
				</tr>
			</tbody>
		</table>

		<div class='underwood-block' v-if='selectedTax.length && selectedTax[0].underwood'>
			<span><span class='underwood-label'>Подрост:</span> {{ selectedTax[0].underwood }}</span>
		</div>

		<div class='btn-row'>
			<button @click='backToLpo' v-if='$route.params.lpo_id'>Вернуться к обследованию</button>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		name: 'TaxDataTable',
		computed: {
			liquidMoreFelling() {
				return this.selectedTax.length && (this.selectedTax[0].stock_liquid_debris > this.selectedTax[0].stock_felling_debris);
			},

			startLayerList() {
				const result = [];
				for (const item of this.selectedTax) {
					if (!result.find(row => row.layer === item.layer)) {
						result.push(item);
					}
				}
				return result;
			},

			...mapState('taxInfo', {
				selectedTax: state => state['selectedTax']
			})
		},
		methods: {
			isStartLayer(item) {
				return this.startLayerList.find(row => row.tax_species_id === item.tax_species_id);
			},
			getLayerRowCount(item) {
				return this.selectedTax.filter(row => row.layer === item.layer).length;
			},

			layerSpeciesCount(layer) {
				return layer.species.filter(species => species.is_extra !== 't').length;
				
			},

			totalSpeciesCount() {
				let num = 0;

				for (const layer of this.selectedTax.layers) {
					num += this.layerSpeciesCount(layer);
				}

				return num;
			},

			backToLpo() {
				const route_obj = {
					name: 'lpo',
					params: {
						lpo_id: this.$route.params.lpo_id,
					}
				};
				this.$router.push(route_obj);
			}
		}
	};
</script>

<style scoped src='@/style/table.css'></style>

<style scoped>
	.underwood-block {
		margin-top: 10px;
	}
	.underwood-label {
		font-style: italic;
		font-weight: bold;
	}

	.btn-row {
		margin-top: 10px;
	}
</style>